<template>
  <div>
    <v-row class="ma-2">
      <v-col cols="auto"> Nápověda: </v-col>

      <v-col cols="auto">
        <Tooltip :showIcon="true" :dvojtecka="false" :smallText="true" :text="'Příprava stanice'" :tooltip="tooltipStationSetup"> </Tooltip>
      </v-col>

      <v-col cols="auto">
        <Tooltip :showIcon="true" :dvojtecka="false" :smallText="true" :text="'Nastavení PC'" :tooltip="tooltipPCSetup"> </Tooltip>
      </v-col>

      <v-col cols="auto">
        <Tooltip :showIcon="true" :dvojtecka="false" :smallText="true" :text="'Přepojení stanice'" :tooltip="tooltipStationRewire"> </Tooltip>
      </v-col>

      <v-col cols="auto">
        <Tooltip :showIcon="true" :dvojtecka="false" :smallText="true" :text="'Konec zkoušky'" :tooltip="tooltipEndOfTest"> </Tooltip>
      </v-col>
    </v-row>

    <template v-if="data != null && parameters != null">
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1" editable> {{ steps[0] }} </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 2" step="2" editable> {{ steps[1] }} </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 3" step="3" editable>{{ steps[2] }} </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 4" step="4" editable>{{ steps[3] }} </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 5" step="5" editable>{{ steps[4] }} </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 6" step="6" editable>{{ steps[5] }} </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="step > 7" step="7" editable>{{ steps[6] }} </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="8" editable>{{ steps[7] }} </v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card class="mb-6" :color="getCardColor" height="auto">
              <v-row class="ma-2">
                <v-col cols="12">
                  <h3>Sériové čísla</h3>
                  <!-- <i></i> -->
                  <br />
                </v-col>

                <v-col cols="12"> 1) Propojit HDO X1.17-X1.18 </v-col>
                <v-col cols="12"> 2) Propojit HLEN X1.19-X1.20 </v-col>
                <v-col cols="12"> 3) Elektroměr připojit na X1.22 a X1.23 (vidlička nápisem nahoru) </v-col>
                <v-col cols="12"> 4) CAN od baterií (DAB) připojit na X2.3 a X2.4 (vidlička nápisem nahoru) </v-col>
                <v-col cols="12"> 5) Připojit GRID, síťové vodiče L1,L2,L3,N </v-col>
                <v-col cols="12"> 6) Připojit Ethernet kabel </v-col>
                <v-col cols="12"> 7) Nastavit adresy na DIP switchi na jednotlivém MPPT </v-col>
                <v-col cols="12"> 8) Připojit externí testovací zdroj 24V na řídící desku </v-col>
                <v-col cols="12"> 9) Připojit Phoenix zdroje na vstupy MPPT </v-col>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card class="mb-6" :color="getCardColor" height="auto">
              <v-row class="ma-2">
                <v-col cols="12">
                  <h3>Sériové čísla</h3>
                  <!-- <i></i> -->
                  <br />

                  V záložce <b>NASTAVENÍ</b> - <b>NASTAVENÍ STANICE</b> <br />
                  Podle google tabulky <b>EC Sériová čísla</b> vybrat si volné seriové číslo a nastavit ho do kolonky <b>Sériové číslo</b> a <b>Identifikátor</b> <br />
                  Do Identifikátoru objektu nastavit SKLADEC <br />
                  <br />
                  V záložce <b>NASTAVENÍ</b> - <b>ZÁKLADNÍ INFORMACE</b> <br />
                  Opsat seriové čísla z vyčtených jednotek do google tabulky (EC Sériová čísla) <br />
                  <i>Pozn. Pokud jednotka posílá INVALID-SERIAL-NUMBER, seriové číslo není nahrané nebo jednotka není přítomná</i>
                </v-col>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card class="mb-6" :color="getCardColor" height="auto">
              <v-row class="ma-2">
                <v-col cols="12">
                  <h3>Funkční test zapojení stykačů</h3>
                </v-col>

                <v-col cols="12"> <v-alert type="warning"> Zde je potřeba, aby byl odpojený grid (nebylo přítomné napětí na svorkách stanice) a byl připojen k řidící jednotce střídače externí zdroj 24V.</v-alert> </v-col>

                <v-col cols="12"> 1) Stisknout tlačítko nastavit testovací režim. State musí být ve stavu TestModeERR_TestMode </v-col>

                <v-col cols="12">
                  <v-btn color="primary" elevation="6" @click="sendCommand('testmode')"> Nastavit testovací režim </v-btn>
                </v-col>

                <template v-if="'inverter' in data">
                  <template v-if="'state' in data.inverter">
                    <v-col cols="12">
                      Stav v reálným čase: <b>{{ data.inverter.state }}</b>
                    </v-col>
                  </template>
                </template>

                <v-col cols="12"> 2) Stisknout tlačítko spustit test relátek </v-col>

                <v-col cols="12">
                  <v-btn color="primary" elevation="6" @click="sendCommand('relaystest')"> Spustit test relátek </v-btn>
                </v-col>

                <v-col cols="12"> 3) Spustí se testovaní stykačů a jejich zpetných vazeb. Spínání ve stanici lze slyšet. </v-col>

                <v-col cols="12"> 4) Během testu a jeho skončení nesmí být žádná chyba. Pokud nastane chyba je potřeba překontrolovat zapojení stykačů. </v-col>

                <v-col cols="12">
                  <template v-if="'inverter' in data">
                    <template v-if="'error1' in data.inverter">
                      Chyby v reálném čase: <b>{{ data.inverter.error1 == "" ? "Bez chyby" : data.inverter.error1 }}</b> <br />
                    </template>

                    <br />
                    <i>od CCU 41.29 verze:</i>
                    <template v-if="'error1Code' in data.inverter">
                      <template v-if="relays.length != 0">
                        <v-row dense>
                          <v-col cols="12" md="3">
                            <template v-if="relays[0] === 0"> <v-icon color="green"> mdi-check </v-icon> </template>
                            <template v-else> <v-icon color="red"> mdi-close </v-icon> </template>
                            Test č.1
                          </v-col>
                          <v-col cols="12" md="9">
                            <v-row dense>
                              <v-col cols="4">
                                <b>Nastavení</b>
                              </v-col>
                              <v-col cols="8"> Grid <v-icon color="primary"> mdi-electric-switch </v-icon> Bypass <v-icon color="primary"> mdi-electric-switch </v-icon> Backup <v-icon color="primary"> mdi-electric-switch </v-icon> PEN <v-icon color="primary"> mdi-electric-switch </v-icon> </v-col>
                              <v-col cols="4">
                                <b>Kontrola zpětných vazeb</b>
                              </v-col>
                              <v-col cols="8">
                                Grid <v-icon color="primary"> mdi-electric-switch </v-icon> Bypass <v-icon color="primary"> mdi-electric-switch-closed</v-icon> Backup <v-icon color="primary"> mdi-electric-switch </v-icon> PEN <v-icon color="primary"> mdi-electric-switch </v-icon>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col cols="12" md="3">
                            <template v-if="relays[1] === 0"> <v-icon color="green"> mdi-check </v-icon> </template>
                            <template v-else> <v-icon color="red"> mdi-close </v-icon> </template>
                            Test č.2
                          </v-col>
                          <v-col cols="12" md="9">
                            <v-row dense>
                              <v-col cols="4">
                                <b>Nastavení</b>
                              </v-col>
                              <v-col cols="8"> Grid <v-icon color="primary"> mdi-electric-switch-closed </v-icon> </v-col>
                              <v-col cols="4">
                                <b>Kontrola zpětných vazeb</b>
                              </v-col>
                              <v-col cols="8"> Grid <v-icon color="primary"> mdi-electric-switch-closed </v-icon> </v-col>
                            </v-row>
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col cols="12" md="3">
                            <template v-if="relays[2] === 0"> <v-icon color="green"> mdi-check </v-icon> </template>
                            <template v-else> <v-icon color="red"> mdi-close </v-icon> </template>
                            Test č.3
                          </v-col>
                          <v-col cols="12" md="9">
                            <v-row dense>
                              <v-col cols="4">
                                <b>Nastavení</b>
                              </v-col>
                              <v-col cols="8"> Bypass <v-icon color="primary"> mdi-electric-switch-closed </v-icon> </v-col>
                              <v-col cols="4">
                                <b>Kontrola zpětných vazeb</b>
                              </v-col>
                              <v-col cols="8"> Bypass <v-icon color="primary"> mdi-electric-switch </v-icon> </v-col>
                            </v-row>
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col cols="12" md="3">
                            <template v-if="relays[3] === 0"> <v-icon color="green"> mdi-check </v-icon> </template>
                            <template v-else> <v-icon color="red"> mdi-close </v-icon> </template>
                            Test č.4
                          </v-col>
                          <v-col cols="12" md="9">
                            <v-row dense>
                              <v-col cols="4">
                                <b>Nastavení</b>
                              </v-col>
                              <v-col cols="8"> Bypass <v-icon color="primary"> mdi-electric-switch-closed </v-icon> Backup <v-icon color="primary"> mdi-electric-switch-closed </v-icon> </v-col>
                              <v-col cols="4">
                                <b>Kontrola zpětných vazeb</b>
                              </v-col>
                              <v-col cols="8"> Bypass <v-icon color="primary"> mdi-electric-switch </v-icon> Backup <v-icon color="primary"> mdi-electric-switch-closed </v-icon> </v-col>
                            </v-row>
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col cols="12" md="3">
                            <template v-if="relays[4] === 0"> <v-icon color="green"> mdi-check </v-icon> </template>
                            <template v-else> <v-icon color="red"> mdi-close </v-icon> </template>
                            Test č.5
                          </v-col>
                          <v-col cols="12" md="9">
                            <v-row dense>
                              <v-col cols="4">
                                <b>Nastavení</b>
                              </v-col>
                              <v-col cols="8"> Backup <v-icon color="primary"> mdi-electric-switch-closed </v-icon> </v-col>
                              <v-col cols="4">
                                <b>Kontrola zpětných vazeb</b>
                              </v-col>
                              <v-col cols="8"> Backup <v-icon color="primary"> mdi-electric-switch </v-icon> </v-col>
                            </v-row>
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col cols="12" md="3">
                            <template v-if="relays[5] === 0"> <v-icon color="green"> mdi-check </v-icon> </template>
                            <template v-else> <v-icon color="red"> mdi-close </v-icon> </template>
                            Test č.6
                          </v-col>
                          <v-col cols="12" md="9">
                            <v-row dense>
                              <v-col cols="4">
                                <b>Nastavení</b>
                              </v-col>
                              <v-col cols="8"> PEN <v-icon color="primary"> mdi-electric-switch-closed </v-icon> </v-col>
                              <v-col cols="4">
                                <b>Kontrola zpětných vazeb</b>
                              </v-col>
                              <v-col cols="8"> PEN <v-icon color="primary"> mdi-electric-switch-closed </v-icon> </v-col>
                            </v-row>
                          </v-col>
                        </v-row>

                        <v-row dense>
                          <v-col cols="12" md="3">
                            <template v-if="relays[6] === 0"> <v-icon color="green"> mdi-check </v-icon> </template>
                            <template v-else> <v-icon color="red"> mdi-close </v-icon> </template>
                            Test č.7
                          </v-col>
                          <v-col cols="12" md="9">
                            <v-row dense>
                              <v-col cols="4">
                                <b>Nastavení</b>
                              </v-col>
                              <v-col cols="8">
                                Grid <v-icon color="primary"> mdi-electric-switch-closed </v-icon> Bypass <v-icon color="primary"> mdi-electric-switch-closed </v-icon> Backup <v-icon color="primary"> mdi-electric-switch-closed </v-icon> PEN
                                <v-icon color="primary"> mdi-electric-switch-closed </v-icon>
                              </v-col>
                              <v-col cols="4">
                                <b>Kontrola zpětných vazeb</b>
                              </v-col>
                              <v-col cols="8">
                                Grid <v-icon color="primary"> mdi-electric-switch-closed </v-icon> Bypass <v-icon color="primary"> mdi-electric-switch</v-icon> Backup <v-icon color="primary"> mdi-electric-switch-closed </v-icon> PEN <v-icon color="primary"> mdi-electric-switch-closed </v-icon>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </template>
                    </template>
                  </template>
                </v-col>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="4">
            <v-card class="mb-6" :color="getCardColor" height="auto">
              <v-row class="ma-2">
                <v-col cols="12">
                  <h3>Kontrola elektroměru</h3>
                </v-col>

                <v-col cols="12"> Kontrola přítomnosti napětí a komunikace na externím elektroměru. </v-col>

                <v-col cols="12"> Zkontrolujte, že napětí na externím elektroměru odpovídá 230V +- 15%. </v-col>
              </v-row>
              <v-row class="mx-4" dense>
                <v-col cols="12"> Externí elektroměr: </v-col>

                <v-col class="mx-2" cols="12">
                  U: <b>{{ data.grid.external.u1 }} V {{ data.grid.external.i1 }} A {{ data.grid.external.p1 }} kW</b>
                </v-col>
                <v-col class="mx-2" cols="12">
                  V: <b>{{ data.grid.external.u2 }} V {{ data.grid.external.i2 }} A {{ data.grid.external.p2 }} kW</b>
                </v-col>
                <v-col class="mx-2" cols="12">
                  W: <b>{{ data.grid.external.u3 }} V {{ data.grid.external.i3 }} A {{ data.grid.external.p3 }} kW</b>
                </v-col>

                <v-col cols="12"> Gridové svorky stanice: </v-col>
                <v-col class="mx-2" cols="12">
                  U: <b>{{ data.grid.internal.u1 }} V {{ data.grid.internal.i1 }} A {{ data.grid.internal.p1 }} kW</b>
                </v-col>
                <v-col class="mx-2" cols="12">
                  V: <b>{{ data.grid.internal.u2 }} V {{ data.grid.internal.i2 }} A {{ data.grid.internal.p2 }} kW</b>
                </v-col>
                <v-col class="mx-2" cols="12">
                  W: <b>{{ data.grid.internal.u3 }} V {{ data.grid.internal.i3 }} A {{ data.grid.internal.p3 }} kW</b>
                </v-col>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="5">
            <v-card class="mb-6" :color="getCardColor" height="auto">
              <v-row class="ma-2">
                <v-col cols="12">
                  <h3>Přepojení stanice</h3>
                </v-col>

                <v-col cols="12"> 1) Přepojit zdroj na řídící desce </v-col>
                <v-col cols="12"> 2) Připojit phoenix zdroje na vstupy MPPT </v-col>
                <v-col cols="12"> 3) Zapnout vypínač u GRID rozvadeče s elektroměrem </v-col>
                <v-col cols="12"> 4) Zapnout 1F jistič ve stanici pro palubní napájení </v-col>
                <v-col cols="12"> 5) Skisknout tlačítko POWER </v-col>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="6">
            <v-card class="mb-6" :color="getCardColor" height="auto">
              <v-row class="ma-2">
                <v-col cols="12">
                  <h3>Test Ventilátorů</h3>
                </v-col>

                <v-col cols="12">Podle počtu ventilátorů nastavit na posledním instalovaném MPPT ventilátory na 100% (tam kam jsou připojeny ventilátory - Zpravidla MPP1 nebo MPPT2) </v-col>
                <v-col cols="12">Sledovat požadavek a zpětnou vazbu ventilátorů, po ověření vrátit přepínač do výchozí polohy </v-col>

                <v-col cols="12" md="2" sm="4" v-for="(item, index) in parameter.mppt.generalConfigBits.fansAllwaysON" :key="index + 'A'">
                  <b>MPPT{{ index + 1 }}</b>
                  <v-switch dense v-model="item.bitValue" @change="sendBitValue(item)" :label="getLabel(item)" color="primary"> </v-switch>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="auto" class="mx-4">
                  <b>MPPT1:</b>
                </v-col>

                <v-col cols="auto"> {{ $t("advanced.fanRequest") }} -> </v-col>

                <v-col cols="auto">
                  <Fans :data="data.mppt[0].fan1Request" :index="1" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[0].fan2Request" :index="2" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[0].fan3Request" :index="3" :label="'FAN '" />
                </v-col>

                <v-col cols="auto"> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t("advanced.fanFeedback") }} -> </v-col>

                <v-col cols="auto">
                  <Fans :data="data.mppt[0].fan1Feedback" :index="1" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[0].fan2Feedback" :index="2" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[0].fan3Feedback" :index="3" :label="'FAN '" />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="auto" class="mx-4">
                  <b>MPPT2:</b>
                </v-col>

                <v-col cols="auto"> {{ $t("advanced.fanRequest") }} -> </v-col>

                <v-col cols="auto">
                  <Fans :data="data.mppt[1].fan1Request" :index="1" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[1].fan2Request" :index="2" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[1].fan3Request" :index="3" :label="'FAN '" />
                </v-col>

                <v-col cols="auto"> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t("advanced.fanFeedback") }} -> </v-col>

                <v-col cols="auto">
                  <Fans :data="data.mppt[1].fan1Feedback" :index="1" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[1].fan2Feedback" :index="2" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[1].fan3Feedback" :index="3" :label="'FAN '" />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="auto" class="mx-4">
                  <b>MPPT3:</b>
                </v-col>

                <v-col cols="auto"> {{ $t("advanced.fanRequest") }} -> </v-col>

                <v-col cols="auto">
                  <Fans :data="data.mppt[2].fan1Request" :index="1" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[2].fan2Request" :index="2" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[2].fan3Request" :index="3" :label="'FAN '" />
                </v-col>

                <v-col cols="auto"> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t("advanced.fanFeedback") }} -> </v-col>

                <v-col cols="auto">
                  <Fans :data="data.mppt[2].fan1Feedback" :index="1" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[2].fan2Feedback" :index="2" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[2].fan3Feedback" :index="3" :label="'FAN '" />
                </v-col>
              </v-row>

              <v-row dense>
                <v-col cols="auto" class="mx-4">
                  <b>MPPT4:</b>
                </v-col>

                <v-col cols="auto"> {{ $t("advanced.fanRequest") }} -> </v-col>

                <v-col cols="auto">
                  <Fans :data="data.mppt[3].fan1Request" :index="1" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[3].fan2Request" :index="2" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[3].fan3Request" :index="3" :label="'FAN '" />
                </v-col>

                <v-col cols="auto"> &nbsp;&nbsp;&nbsp;&nbsp;{{ $t("advanced.fanFeedback") }} -> </v-col>

                <v-col cols="auto">
                  <Fans :data="data.mppt[3].fan1Feedback" :index="1" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[3].fan2Feedback" :index="2" :label="'FAN '" />
                </v-col>
                <v-col cols="auto">
                  <Fans :data="data.mppt[3].fan3Feedback" :index="3" :label="'FAN '" />
                </v-col>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="7">
            <v-card class="mb-6" :color="getCardColor" height="auto">
              <v-row class="ma-2" dense>
                <v-col cols="12">
                  <h3>Finální zkouška</h3>
                </v-col>

                <v-col cols="12"> Pro finální zkoušku dočasně povolte a nastavte následující parametry </v-col>

                <v-col cols="12" md="auto" v-for="(item, index) in parameter.inv.generalConfigBits.overflowsEnabled" :key="index + 'C'">
                  <v-switch dense v-model="item.bitValue" @change="sendBitValue(item)" :label="getLabel(item)" color="primary"> </v-switch>
                </v-col>

                <v-col cols="12" md="auto" v-for="(item, index) in parameter.inv.generalConfigBits.invAutomaticStart" :key="index + 'D'">
                  <v-switch dense v-model="item.bitValue" @change="sendBitValue(item)" :label="getLabel(item)" color="primary"> </v-switch>
                </v-col>

                <v-col cols="12">2) Pozorovací časy dočasně nastavte na 10s </v-col>

                <v-col cols="12" md="2" sm="4" v-for="(item, index) in parameter.inv.automaticReconnectionAfterTripping_ObservationTime" :key="index + 'E'">
                  <v-text-field @focus="stopTimer" v-model="item.parameterValue" @change="sendValue(item)" type="number" :label="getLabel(item)"></v-text-field>
                </v-col>

                <v-col cols="12" md="2" sm="4" v-for="(item, index) in parameter.inv.startingToGenerateElectricalPower_ObservationTime" :key="index + 'F'">
                  <v-text-field @focus="stopTimer" v-model="item.parameterValue" @change="sendValue(item)" type="number" :label="getLabel(item)"></v-text-field>
                </v-col>

                <v-col cols="12">3) Režimy regulace MPPT na 2 </v-col>

                <v-col cols="12" md="2" sm="4" v-for="(item, index) in parameter.mppt.mpptMode" :key="index + 'G'">
                  <i class="caption">MPPT {{ index + 1 }}</i>
                  <v-text-field @focus="stopTimer" v-model="item.parameterValue" @change="sendValue(item)" type="number" :label="getLabel(item)"></v-text-field>
                </v-col>

                <v-col cols="12">4) Pomocí druhého PC zapnout Phoenix zdroje </v-col>
                <v-col cols="12">5) Zkontrolovat vstupní napětí MPPT cca 100V (podle počtu zdrojů a MPPT) </v-col>
              </v-row>

              <v-row class="ma-2" dense>
                <v-col class="mx-4" cols="12"> Vstupní napětí, proudy a výkony MPPT: </v-col>
                <v-col class="mx-8" cols="12">
                  MPPT1: <b>{{ data.mppt[0].uIn }} V </b> <b>{{ data.mppt[0].iIn }} A </b> <b>{{ data.mppt[0].powerOut }} kW </b>
                </v-col>
                <v-col class="mx-8" cols="12">
                  MPPT2: <b>{{ data.mppt[1].uIn }} V </b> <b>{{ data.mppt[1].iIn }} V </b> <b>{{ data.mppt[1].powerOut }} kW </b>
                </v-col>
                <v-col class="mx-8" cols="12">
                  MPPT3: <b>{{ data.mppt[2].uIn }} V </b> <b>{{ data.mppt[2].iIn }} V </b> <b>{{ data.mppt[2].powerOut }} kW </b>
                </v-col>
                <v-col class="mx-8" cols="12">
                  MPPT4: <b>{{ data.mppt[3].uIn }} V </b> <b>{{ data.mppt[3].iIn }} V </b> <b>{{ data.mppt[3].powerOut }} kW </b>
                </v-col>
              </v-row>

              <v-row class="ma-2" dense>
                <v-col cols="12">6) Phoenix zdroje nastavit na 500V </v-col>
              </v-row>

              <v-row class="ma-2" dense>
                <v-col cols="12">7) Po cca 10s by se měla stanice přifázovat ke GRIDU. Sledovat výstupní výkon. Po dosáhnutí maximálního výkonu na všech fází nechat běžet min. 15min (zahoření). </v-col>
              </v-row>

              <v-row class="ma-2" dense>
                <v-col cols="12" md="4">
                  <v-row dense>
                    <v-col class="mx-2" cols="12">
                      U: <b>{{ data.grid.internal.u1 }} V {{ data.grid.internal.i1 }} A {{ data.grid.internal.p1 }} kW</b>
                    </v-col>
                    <v-col class="mx-2" cols="12">
                      V: <b>{{ data.grid.internal.u2 }} V {{ data.grid.internal.i2 }} A {{ data.grid.internal.p2 }} kW</b>
                    </v-col>
                    <v-col class="mx-2" cols="12">
                      W: <b>{{ data.grid.internal.u3 }} V {{ data.grid.internal.i3 }} A {{ data.grid.internal.p3 }} kW</b>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" md="4">
                  <v-row justify="center">
                    <v-col cols="auto">
                      <v-btn class="ma-2" color="primary" @click="toggle">{{ running ? "Stop" : "Start" }}</v-btn>
                    </v-col>
                    <v-col cols="auto">
                      <v-btn class="ma-2" color="primary" @click="reset" :disabled="running">Reset</v-btn>
                    </v-col>

                    <v-col cols="auto">
                      <h1>{{ formatTime(elapsedTime) }}</h1>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-stepper-content step="8">
            <v-card class="mb-6" :color="getCardColor" height="auto">
              <v-row class="ma-2">
                <v-col cols="12">
                  <h3>Ukončení měření</h3>
                </v-col>

                <v-col cols="12"> 1) Vypnout Phoenix zdroje </v-col>

                <v-col cols="12"> 2) Vypnout gridový vypínač </v-col>

                <v-col cols="12"> 3) Vybít meziobvod </v-col>

                <v-col cols="12"> 4) Odpojit konektory od PHOENIXů </v-col>

                <v-col cols="12"> 5) Vybít vstupy MPPT a GRIDU </v-col>

                <v-col cols="12"> 6) Odpojit kabely </v-col>
              </v-row>
            </v-card>
          </v-stepper-content>

          <v-row class="ma-2">
            <v-col cols="12" md="3" sm="6">
              <v-btn :disabled="step === steps.length" color="primary" @click="nextStep()"> Pokračovat </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3" sm="6">
              <v-btn :disabled="step === 1" color="primary" @click="prevStep()" text> Zpět </v-btn>
            </v-col>
          </v-row>
        </v-stepper-items>
      </v-stepper>

      <!--  23x) Vygenerovat protokol se sériovými čísly včteně provedených testů a vytáhnutí parametrů, kontrola měření, výpis parametrů do protokolu  -->
    </template>
    <template v-else>
      <LoadingData />
    </template>
  </div>
</template>

<script>
import { ServiceClient } from "../../service_client/index.js";

import Fans from "../../components/Fans.vue";
import Tooltip from "../../components/Tooltip.vue";
import LoadingData from "../LoadingData.vue";

export default {
  name: "StationTesting",

  props: {},
  components: {
    Fans,
    Tooltip,
    LoadingData,
  },
  data() {
    return {
      running: false,
      startTime: null,
      elapsedTime: 0,
      laps: [],

      timer1: null,
      timer2: null,

      data: null,
      parameters: null,

      tooltipStationSetup:
        " 1) Propojit HDO X1.17-X1.18\n 2) Propojit HLEN X1.19-X1.20 \n 3) Elektroměr připojit na X1.22 a X1.23 (vidlička nápisem nahoru) \n 4) CAN od baterií (DAB) připojit na X2.3 a X2.4 (vidlička nápisem nahoru) \n 5) Připojit GRID, síťové vodiče L1,L2,L3,N \n 6) Připojit Ethernet kabel \n 7) Nastavit adresy na DIP switchi na jednotlivém MPPT \n 8) Připojit externí testovací zdroj 24V na řídící desku \n 9) Připojit Phoenix zdroje na vstupy MPPT",

      tooltipPCSetup:
        " 1) Propojit síťový kabel STANICE a PC\n 2) Nastavení statické IP adresy (provádí se pouze jednou)\n a) Pomocí terminálu \n\t K tomu je potřeba znát ID síťovky: Tu lze zjistit pomocí terminálového příkazu ifconfig\n\t (pokud není dostupný ifconfig lze ho nainstalovat pomocí terminálového příkazu: sudo apt install net-tools )\n\t Po provedení ifconfig se vypíše aktuální konfigurace pro síťové rozhraní zajímá nás ID začínající enx (např. enxc025a546d15e)\n\t Po zjištění ID provést následující příkaz sudo ifconfig enxc025a546d15e 192.168.199.198 netmask 255.255.0.0\n b) Pomocí GUI \n\t V Nastavení linuxu -> V záložce Network (Síť) -> Drátové připojení -> Nastavení -> IPv4 -> Manual -> \n\t V Addresses vyplnit Address 192.168.199.198 a Netmask 255.255.255.0 \n 3) V prohlížeči otevřít http://192.168.199.199 přivítá nás přihlašovací formulář do kterého je potřeba se přihlásit jako ecadmin a do URL v přihlašovacím formuláři zadat http://192.168.199.199:8092 \n ",

      tooltipStationRewire: " 1) Přepojit zdroj na řídící desce\n 2) Připojit phoenix zdroje na vstupy MPPT\n 3) Zapnout vypínač u GRID rozvadeče s elektroměrem\n 4) Zapnout 1F jistič ve stanici pro palubní napájení\n 5) Skisknout tlačítko POWER",

      tooltipEndOfTest: " 1) Test u konce\n 2) Vypnout Phoenix zdroje\n 3) Vypnout gridový vypínač\n 4) Vypnout meziobvod\n 5) Odpojit konektory od PHOENIXů\n 6) Vybít vstupy MPPT a GRIDU\n 7) Odpojit kabely\n",

      parameter: {
        inv: {
          automaticReconnectionAfterTripping_ObservationTime: null,
          startingToGenerateElectricalPower_ObservationTime: null,
          generalConfigBits: {
            overflowsEnabled: null,
            invAutomaticStart: null,
          },
        },
        mppt: {
          mpptMode: null,
          generalConfigBits: {
            fansAllwaysON: null,
          },
        },
      },

      relays: [],

      step: 1,
      steps: ["Příprava stanice", "Sériové čísla", "Funkční test zapojení stykačů", "Kontrola napětí na elektroměru", "Přepojení stanice", "Test Ventilátorů", "Finální zkouška", "Ukončení měření"],
    };
  },
  created() {
    this.getData();
    this.getParameters();
  },
  mounted() {
    this.pollData();
    this.pollParameters();
  },
  computed: {
    getCardColor() {
      return this.$vuetify.theme.dark == true ? "#0000003F" : "grey lighten-3";
    },
  },
  methods: {
    toggle() {
      if (this.running) {
        clearInterval(this.interval);
        this.interval = null;
        this.running = false;
      } else {
        this.startTime = Date.now() - this.elapsedTime;
        this.interval = setInterval(this.updateTime, 10);
        this.running = true;
      }
    },
    updateTime() {
      this.elapsedTime = Date.now() - this.startTime;
    },
    reset() {
      if (!this.running) {
        this.elapsedTime = 0;
        this.laps = [];
      }
    },
    formatTime(time) {
      const milliseconds = Math.floor((time % 1000) / 10);
      const seconds = Math.floor(time / 1000) % 60;
      const minutes = Math.floor(time / 1000 / 60) % 60;
      const hours = Math.floor(time / 1000 / 60 / 60);
      return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}.${milliseconds.toString().padStart(2, "0")}`;
    },
    nextStep() {
      if (this.step < this.steps.length) {
        this.step++;
      }
    },
    prevStep() {
      if (this.step > 1) {
        this.step--;
      }
    },
    stopTimer() {
      if (this.timer1 != null) {
        clearInterval(this.timer1);
        this.timer1 = null;
      }
      if (this.timer2 != null) {
        clearInterval(this.timer2);
        this.timer2 = null;
      }
    },
    refreshTimer() {
      if (this.timer1 == null) {
        this.pollData();
      }
      if (this.timer2 == null) {
        this.pollParameters();
      }
    },
    pollData() {
      this.timer1 = setInterval(() => {
        this.getData();
      }, 2500);
    },
    pollParameters() {
      this.timer2 = setInterval(() => {
        this.getParameters();
      }, 2500);
    },
    getData() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("main"), null, null, "GET")
        .then((data) => {
          this.data = data;

          if ("error1Code" in this.data.inverter) {
            for (let index = 0; index < 8; index++) {
              if ((1 << index) & this.data.inverter.error1Code) {
                this.relays[index] = 1;
              } else {
                this.relays[index] = 0;
              }
            }
          }
        })
        .catch((error) => {
          this.data = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    getParameters() {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("parameters"), null, null, "GET")
        .then((data) => {
          this.parameters = data;

          this.parameter.mppt.generalConfigBits.fansAllwaysON = [];
          this.parameter.mppt.mpptMode = [];
          this.parameter.inv.automaticReconnectionAfterTripping_ObservationTime = [];
          this.parameter.inv.startingToGenerateElectricalPower_ObservationTime = [];
          this.parameter.inv.generalConfigBits.overflowsEnabled = [];
          this.parameter.inv.generalConfigBits.invAutomaticStart = [];

          for (let i = 0; i < this.parameters.units.length; i++) {
            if (this.parameters.units[i].type.includes("INV")) {
              for (let j = 0; j < this.parameters.units[i].parameters.length; j++) {
                if (this.parameters.units[i].parameters[j].name.includes("AutomaticReconnectionAfterTripping_ObservationTime")) {
                  this.parameter.inv.automaticReconnectionAfterTripping_ObservationTime.push(
                    this.collectParameter(
                      this.parameters.units[i], //
                      this.parameters.units[i].parameters[j], //
                      null //
                    )
                  );
                }
                if (this.parameters.units[i].parameters[j].name.includes("StartingToGenerateElectricalPower_ObservationTime")) {
                  this.parameter.inv.startingToGenerateElectricalPower_ObservationTime.push(
                    this.collectParameter(
                      this.parameters.units[i], //
                      this.parameters.units[i].parameters[j], //
                      null //
                    )
                  );
                }

                if (this.parameters.units[i].parameters[j].name.includes("GeneralConfigBits")) {
                  for (let k = 0; k < this.parameters.units[i].parameters[j].bits.length; k++) {
                    if (this.parameters.units[i].parameters[j].bits[k].name.includes("OverflowsEnabled")) {
                      this.parameter.inv.generalConfigBits.overflowsEnabled.push(
                        this.collectParameter(
                          this.parameters.units[i], //
                          this.parameters.units[i].parameters[j], //
                          this.parameters.units[i].parameters[j].bits[k] //
                        )
                      );
                    }

                    if (this.parameters.units[i].parameters[j].bits[k].name.includes("InvAutomaticStart")) {
                      this.parameter.inv.generalConfigBits.invAutomaticStart.push(
                        this.collectParameter(
                          this.parameters.units[i], //
                          this.parameters.units[i].parameters[j], //
                          this.parameters.units[i].parameters[j].bits[k] //
                        )
                      );
                    }
                  }
                }
              }
            }
            if (this.parameters.units[i].type.includes("MPPT")) {
              for (let j = 0; j < this.parameters.units[i].parameters.length; j++) {
                if (this.parameters.units[i].parameters[j].name.includes("GeneralConfigBits")) {
                  for (let k = 0; k < this.parameters.units[i].parameters[j].bits.length; k++) {
                    if (this.parameters.units[i].parameters[j].bits[k].name.includes("FansAllwaysON")) {
                      this.parameter.mppt.generalConfigBits.fansAllwaysON.push(
                        this.collectParameter(
                          this.parameters.units[i], //
                          this.parameters.units[i].parameters[j], //
                          this.parameters.units[i].parameters[j].bits[k] //
                        )
                      );
                    }
                  }
                }

                if (this.parameters.units[i].parameters[j].name.includes("MPPTmode")) {
                  this.parameter.mppt.mpptMode.push(
                    this.collectParameter(
                      this.parameters.units[i], //
                      this.parameters.units[i].parameters[j], //
                      null //
                    )
                  );
                }
              }
            }
          }
        })
        .catch((error) => {
          this.parameters = ServiceClient.handleUnauthorized(error, this.$router);
        });
    },
    collectParameter(units, unitsParameters, unitsParametersBits) {
      let obj = {};

      obj = {
        unitAddress: units.address,
        unitType: units.type,
        parameterUnits: unitsParameters.units,
        parameterName: unitsParameters.name,
        parameterValue: unitsParameters.value,
        bitName: unitsParametersBits == null ? "" : unitsParametersBits.name,
        bitValue: unitsParametersBits == null ? "" : unitsParametersBits.value,
      };

      return obj;
    },
    sendCommand(command) {
      ServiceClient.dataCore(ServiceClient.getAPIUrl("command"), null, "?cmd=" + command, "GET").catch((error) => {
        ServiceClient.handleUnauthorized(error, this.$router);
      });
    },
    sendValue(item) {
      if (isNaN(item.parameterValue)) {
        return;
      }

      if (item.parameterValue === true) {
        item.parameterValue = 1;
      }
      if (item.parameterValue === false) {
        item.parameterValue = 0;
      }

      let parameters = "?" + "unit" + "=" + item.unitAddress + "&" + "par" + "=" + item.parameterName + "&" + "val" + "=" + item.parameterValue;

      ServiceClient.dataCore(ServiceClient.getAPIUrl("parameters"), null, parameters, "GET").catch((error) => {
        ServiceClient.handleUnauthorized(error, this.$router);
      });
    },
    sendBitValue(item) {
      this.stopTimer();

      if (isNaN(item.bitValue)) {
        return;
      }

      if (item.bitValue === true) {
        item.bitValue = 1;
      }
      if (item.bitValue === false) {
        item.bitValue = 0;
      }

      let parameters = "?" + "unit" + "=" + item.unitAddress + "&" + "par" + "=" + item.parameterName + "&" + "bit" + "=" + item.bitName + "&" + "val" + "=" + item.bitValue;

      ServiceClient.dataCore(ServiceClient.getAPIUrl("parameters"), null, parameters, "GET").catch((error) => {
        ServiceClient.handleUnauthorized(error, this.$router);
      });
    },
    getLabel(item) {
      let my = "parameters.";

      let myUnit =
        item.unitType == "EINV3H0"
          ? "inverter."
          : item.unitType == "EINV1H0"
          ? "inverter." //
          : item.unitType == "EINV1H1"
          ? "inverter." //
          : item.unitType == "EMPPTH0"
          ? "mppt." //
          : item.unitType == "EMPPTH1"
          ? "mppt." //
          : item.unitType == "EBCU0H0"
          ? "bcu." //
          : item.unitType == "EBATCH0"
          ? "dab." //
          : item.unitType == "EDPBMS1"
          ? "bms." //
          : item.unitType == "XELMET1"
          ? "meter." //
          : item.unitType == "EVCAC02"
          ? "evcac." //
          : item.unitType == "EVCAC01"
          ? "evcac." //
          : item.unitType == "EVCDC01"
          ? "evcdc."
          : 0; //

      let bitName = item.bitName == "" ? "" : "." + item.bitName;

      let parameterUnits = item.parameterUnits == "" ? "" : " [" + item.parameterUnits + "]";

      let l = this.$i18n.t(my + myUnit + item.parameterName + bitName) + parameterUnits;

      return l;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer1);
    clearInterval(this.timer2);
  },
  destroyed() {},
};
</script>

<style scoped></style>
